import React, { createContext, useContext, useState, useEffect } from 'react';
import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';
import QueryError from './components/QueryError';

const CURRENT_USER = gql`
  query CurrentUser {
    currentUser {
      id
      name
      email
      role
    }
  }
`;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useQuery(CURRENT_USER, {
    onCompleted: (data) => setUser(data?.currentUser || null),
    onError: (err) => setError(err),
    onComplete: () => setLoading(false)
  });

  // Also check localStorage for initial state
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const csrfToken =
          document.querySelector('meta[name="csrf-token"]')?.content;
        const res = await fetch('/graphql', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {})
          },
          body: JSON.stringify({ query: CURRENT_USER.loc.source.body }),
          credentials: 'include'
        });
        const json = await res.json();
        setUser(json?.data?.currentUser || null);
      } catch {
        // Network error, will be retried by Apollo
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, []);

  if (loading) return <div className="loading">Loading...</div>;
  if (error)
    return (
      <div className="p-3">
        <QueryError error={error} />
      </div>
    );

  return (
    <AuthContext.Provider value={{ user, loading: false, error: null }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
}
